import { Box, IconButton, Typography, BoxProps } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useNavigate } from 'react-router-dom'

interface PageProps extends Omit<BoxProps, 'title'> {
  title?: string
  onBack?: () => void
  showBackButton?: boolean
}

export default function PageWrapper({
  title,
  onBack,
  showBackButton = true,
  children,
  sx,
  ...rest
}: PageProps) {
  const navigate = useNavigate()
  const handleBack = onBack ?? (() => navigate(-1))

  return (
    <Box sx={styles.root} {...rest}>
      {(title || showBackButton) && (
        <Box display='flex' alignItems='center' gap='12px' flexShrink={0} sx={{ pb: '16px' }}>
          {showBackButton && (
            <IconButton onClick={handleBack} size={'large'}>
              <ArrowBackIcon />
            </IconButton>
          )}
          {title && (
            <Typography variant='h3' fontWeight={700}>
              {title}
            </Typography>
          )}
        </Box>
      )}

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          ...sx,
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    px: '0px',
    pt: '20px',
    pb: '8px',
  },
}
